import { client } from '@atlassian/rovo-content-bridge-api';
var CONFLUENCE_DATABASE_CLIENT_ID_PREFIX = 'confluence-database';
export var getConfluenceDatabaseClientId = function getConfluenceDatabaseClientId(contentId) {
  return client("".concat(CONFLUENCE_DATABASE_CLIENT_ID_PREFIX, "-").concat(contentId));
};